import {
    QueryCategoryByCoIdUsingGet1Params,
    ErpCategoryConfigResult,
    GetCategoryGoodsListUsingGetParams,
    CategoryVo,
    ListUserCategoryByPidUsingGet1Params,
    QueryCategoryTreeUsingGetParams,
    MallCategoryVo,
    CheckSupplierCoIdWhiteListUsingGetParams,
    QueryCategoryByCoIdUsingGetParams,
    LoadSupplierGylCategoryV2UsingGetParams,
    ListUserCategoryByPidUsingGetParams,
    BaseUserCategoryVo
} from '@servicesTypings/goodsRequest'
import { GylSupplierCategory, MainCategoryVo } from '@servicesTypings/drpRequest'
import { goodsRequest, openGoodsRequest, drpRequest, marketRequest, goodsBasicRequest } from '@/utils/request'
import { getCacheService } from '@/utils/requestUtils'

// 供应商是否开启小站展示ERP商品分类
export function queryShowCategoryConfig(params) {
    return goodsBasicRequest.get('/supplierConfig/queryShowCategoryConfig', {
        params
    })
}

// 供应商修改是否开启小站展示ERP商品分类配置
export function updateShowCategoryConfig(data) {
    return goodsBasicRequest.post('/supplierConfig/editShowCategoryConfig', {
        data
    })
}

// 根据商家ID查询ERP类目
/**
 * 根据商家ID查询ERP类目
 */
export function openQueryCategoryByCoId(params: QueryCategoryByCoIdUsingGet1Params): API.Res<ErpCategoryConfigResult> {
    return openGoodsRequest.get('/open/erp/category/queryCategoryByCoId', { params })
}

// 根据商家ID查询ERP类目
/**
 * 查询ERP类目
 */
export function queryCategoryByCoId(params: QueryCategoryByCoIdUsingGetParams): API.Res<ErpCategoryConfigResult> {
    return goodsRequest.get('/erp/category/queryCategoryByCoId', { params })
}

// 查询顶级类目，带淘宝一级类目
/**
 * 查询供应链一级类目分组(带淘宝一级类目)
 */
export function queryCategoryGroupIdIncludeTB(): API.Res<object> {
    return goodsBasicRequest.get('/goCategory/queryCategoryGroup')
}

// 查询多级类目 (多级)
/**
 * swagger找不到此接口
 */
export function queryGoodsMultiCategory(params) {
    return goodsRequest.get('/category/buyer/pc/list/goods', {
        params
    })
}

// 找供应商主营类目列表
export function companyCategory(params) {
    return getCacheService(drpRequest).get('/mainCategory/list', {
        params
    })
}

// 找供应商主营类目列表
export function companyCategoryV1(params) {
    return getCacheService(drpRequest).get('/mainCategory/listByPid', {
        params
    })
}

// 查询商品类目层级结构  大店使用，查询整个树形结构
export function getCateHierarchy() {
    return getCacheService(marketRequest).get('/freshman/goods/category/getCateHierarchy')
}

// 查询商品类目层级结构  大店使用，查询整个树形结构
export function getCateHierarchyV1() {
    return getCacheService(drpRequest).get('/mainCategory/listFreshmanCategoryTree')
}

// 根据叶子类目ID查询类目树 - 大店专用
export function getListByParent(params) {
    return getCacheService(marketRequest).get('/freshman/goods/category/getListByParent', {
        params
    })
}

// 供应商：查询基础资料类目
/**
 * 查询供应链类目（新）
 */
export function querySupplierGylCategory(params: LoadSupplierGylCategoryV2UsingGetParams): API.Res<object> {
    return goodsBasicRequest.get('/goCategory/loadSupplierGylCategoryV2', { params })
}

// 供应商：查询基础资料类目组
/**
 * 获取供应商的主营类目信息,带一级类目
 */
export function querySupplierGroupCategory(): API.Res<GylSupplierCategory[]> {
    return drpRequest.get('/supplierInfo/getSupplierGroupCategory')
}

// 供应商： 更新主营类目
/**
 * 修改商家主营类目
 */
export function updateMainCategory(data: string[]): API.Res<object> {
    return drpRequest.post('/supplierInfo/updateMainCategory', { data })
}

// 查询多级类目 (多级) open
/**
 * 渠道PC获取商品类目列表
 */
export function queryGoodsMultiCategoryOpen(params: GetCategoryGoodsListUsingGetParams): API.Res<CategoryVo[]> {
    return openGoodsRequest.get('/open/category/goods/list', { params })
}

// 大区 (渠道)
/**
 * 获取渠道的销售大区列表
 */
export function queryChannelRegionList(): API.Res<string[]> {
    return drpRequest.get('/op/channel/getRegionList')
}

// 大区 (供应商)
/**
 * 获取供应商的销售大区列表
 */
export function querySupplierRegionList(): API.Res<string[]> {
    return drpRequest.get('/op/supplierInfo/getRegionList')
}

// 查询多级展架类目 (多级)
/**
 * 根据父id查询自定义类目列表
 */
export function queryShelvesMultiCategory(params: ListUserCategoryByPidUsingGetParams): API.Res<BaseUserCategoryVo[]> {
    return goodsRequest.get('/goods/goUserCategory/listUserCategoryByPid', { params })
}

// 查询多级展架类目 (多级) open
/**
 * 根据父id查询自定义类目列表
 */
export function queryShelvesMultiCategoryOpen(
    params: ListUserCategoryByPidUsingGet1Params
): API.Res<BaseUserCategoryVo[]> {
    return openGoodsRequest.get('/open/userCategory/listUserCategoryByPid', { params })
}

// 查询主营类目级联列表
/**
 * 查询主营类目级联列表
 */
export function queryMainCategoryCascadeList(): API.Res<MainCategoryVo[]> {
    return drpRequest.get('/mainCategory/queryMainCategoryCascadeList')
}

/** 查询商家的类目树 */
/**
 * 查询商家的类目树
 */
export function queryCategoryTree(params: QueryCategoryTreeUsingGetParams): API.Res<MallCategoryVo[]> {
    return openGoodsRequest.get('/open/mall/category/queryCategoryTree', { params })
}

/** 判断类目展示白名单 */
/**
 * 判断类目展示白名单
 */
export function checkSupplierCoIdWhiteList(params: CheckSupplierCoIdWhiteListUsingGetParams): API.Res<boolean> {
    return openGoodsRequest.get('/open/mall/category/checkSupplierCoIdWhiteList', { params })
}
